import { render } from "./ui-table-input.vue?vue&type=template&id=27f6b504&scoped=true&ts=true"
import script from "./ui-table-input.vue?vue&type=script&lang=ts"
export * from "./ui-table-input.vue?vue&type=script&lang=ts"

import "./ui-table-input.vue?vue&type=style&index=0&id=27f6b504&scoped=true&lang=css"

import exportComponent from "D:\\Projects\\aba\\aba-cabinet-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27f6b504"]])

export default __exports__